import Goal from './models'

export default Goal
